import {registerBlockType} from '@wordpress/blocks';
import {InnerBlocks, RichText, useBlockProps} from '@wordpress/block-editor';
import {__} from '@wordpress/i18n';

registerBlockType('garden/testimonials', {
  apiVersion: 3,
  title: __('Referencje', 'garden'),
  icon: 'format-quote',
  category: 'garden',
  supports: {
    anchor: true
  },
  attributes: {
    anchor: {
      type: 'string',
      default: ''
    }
  },
  edit: () => {
    const blockProps = useBlockProps({
      className: 'parallax-setting parallaxie parallax1'
    });

    const ALLOWED_BLOCKS = ['garden/testimonial'];
    const TEMPLATE = [
      ['garden/testimonial'],
    ];

    return (
      <div {...blockProps}>
        <div className="testimonials-container">
          <InnerBlocks
            allowedBlocks={ALLOWED_BLOCKS}
            template={TEMPLATE}
            orientation="horizontal"
          />
        </div>
      </div>
    );
  },
  save: function Save() {
    const blockProps = useBlockProps.save({
      className: 'wp-block parallax-setting parallaxie parallax1'
    });

    return (
      <div {...blockProps}>
        <div className="testimonials-container">
          <div className="swiper testimonial-swiper js-testimonial-swiper">
            <div className="swiper-wrapper">
              <InnerBlocks.Content/>
            </div>
            <div className="swiper-pagination"></div>
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
          </div>
        </div>
      </div>
    );
  }
});

// Register testimonial block
registerBlockType('garden/testimonial', {
  apiVersion: 3,
  title: __('Referencja', 'garden'),
  icon: 'yes-alt',
  category: 'garden',
  parent: ['garden/testimonials'],
  attributes: {
    quote: {
      type: 'string',
      source: 'html',
      selector: 'blockquote p'
    },
    cite: {
      type: 'string',
      source: 'html',
      selector: 'blockquote cite'
    }
  },
  edit: ({attributes, setAttributes}) => {
    const blockProps = useBlockProps();

    return (
      <div {...blockProps}>
        <blockquote>
          <RichText
            tagName="p"
            value={attributes.quote}
            onChange={(quote) => setAttributes({quote})}
            placeholder={__('Wprowadź tekst cytatu...', 'psgarden')}
          />
          <RichText
            tagName="cite"
            value={attributes.cite}
            onChange={(cite) => setAttributes({cite})}
            placeholder={__('Wpisz autora...', 'psgarden')}
          />
        </blockquote>
      </div>
    );
  },
  save: ({attributes}) => {
    const blockProps = useBlockProps.save({
      className: 'wp-block swiper-slide'
    });

    return (
      <div {...blockProps}>
        <blockquote>
          <div className="quote-first">
            <i className="fa fa-quote-left"></i>
          </div>
          <RichText.Content
            tagName="p"
            value={attributes.quote}
          />
          <RichText.Content
            tagName="cite"
            value={attributes.cite}
          />
          <div className="quote-last">
            <i className="fa fa-quote-right"></i>
          </div>
        </blockquote>
      </div>
    );
  }
}); 
